import { render } from "./CreditCard.vue?vue&type=template&id=252bc3ed&scoped=true"
import script from "./CreditCard.vue?vue&type=script&lang=js"
export * from "./CreditCard.vue?vue&type=script&lang=js"

import "./CreditCard.vue?vue&type=style&index=0&id=252bc3ed&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-252bc3ed"]])

export default __exports__